import React, { useState, useEffect } from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import axiosInstance from '../../services/api/axios';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const UsageGraph = ({ customerId }) => {
  const [usageData, setUsageData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUsageData = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await axiosInstance(
          `/customer/property/usage?customer_id=${customerId}` // Construct the API URL
        );

     
      
        setUsageData(response);
      } catch (error) {
        setError(error);
        console.error('Error fetching usage data:', error);
      } finally {
        setLoading(false);
      }
    };

    if (customerId) {
      fetchUsageData();
    }
  }, [customerId]);

  const chartData = {
    labels: usageData.map((item) => `${item.year}-${String(item.month).padStart(2, '0')}`), // Format labels
    datasets: [
      {
        label: 'Active Property Count',
        data: usageData.map((item) => item.activePropertyCount),
        fill: false,
        backgroundColor: 'rgb(75, 192, 192)',
        borderColor: 'rgba(75, 192, 192, 0.2)',
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: 'Customer Property Usage History',
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Year-Month',
        },
      },
      y: {
        title: {
          display: true,
          text: 'Active Property Count',
        },
      },
    },
  };

  if (loading) {
    return <p>Loading usage data...</p>;
  }

  if (error) {
    return <p>Error: {error.message}</p>;
  }

  if (!usageData || usageData.length === 0) {
    return <p>No usage data available.</p>;
  }

  return <Line data={chartData} options={options} />;
};

export default UsageGraph;